<mat-toolbar color="primary" class="toolbar">
  <ng-content></ng-content>
</mat-toolbar>
